import { createSlice } from '@reduxjs/toolkit';

const initialState = 'loading';

const uiSlice = createSlice({
	name: 'ui',
	initialState,
	reducers: {
		loginStatus: (state, action) => {
			return action.payload;
		}
	}
});

export const { loginStatus } = uiSlice.actions;
export default uiSlice.reducer;
